/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getPolls = /* GraphQL */ `
  query GetPolls($targetType: String!, $targetValue: String) {
    getPolls(targetType: $targetType, targetValue: $targetValue) {
      pollId
      title
      message
      description
      category
      options {
        optionId
        text
        __typename
      }
      status
      target_type
      target_value
      start_time
      end_time
      vote_counts
      created_at
      subscription_topic
      poll_display_id
      knowledge_base_url
      age_group
      __typename
    }
  }
`;
export const getPoll = /* GraphQL */ `
  query GetPoll($input: getPollInput) {
    getPoll(input: $input)
  }
`;
export const getOverAllPolls = /* GraphQL */ `
  query GetOverAllPolls($input: getOverAllPollsInput) {
    getOverAllPolls(input: $input)
  }
`;
export const getWorkFlows = /* GraphQL */ `
  query GetWorkFlows($input: getWorkFlowsInput) {
    getWorkFlows(input: $input)
  }
`;
export const getDemographicVoteDetails = /* GraphQL */ `
  query GetDemographicVoteDetails($input: getDemographicVoteDetailsInput) {
    getDemographicVoteDetails(input: $input)
  }
`;
export const getCurrentUser = /* GraphQL */ `
  query GetCurrentUser($input: getCurrentUserInput) {
    getCurrentUser(input: $input)
  }
`;
export const listCuratorPolls = /* GraphQL */ `
  query ListCuratorPolls($input: listCuratorPollsInput) {
    listCuratorPolls(input: $input)
  }
`;
export const listWorkflows = /* GraphQL */ `
  query ListWorkflows($input: listWorkflowsInput) {
    listWorkflows(input: $input)
  }
`;
export const listPrivatePolls = /* GraphQL */ `
  query ListPrivatePolls($input: listPrivatePollsInput) {
    listPrivatePolls(input: $input)
  }
`;
export const getScratchPadData = /* GraphQL */ `
  query GetScratchPadData($input: getScratchPadDataInput) {
    getScratchPadData(input: $input)
  }
`;
export const getDashboardData = /* GraphQL */ `
  query GetDashboardData($input: getDashboardDataInput) {
    getDashboardData(input: $input)
  }
`;
export const getUserStatsDistribution = /* GraphQL */ `
  query GetUserStatsDistribution($input: GetUserStatsDistributionInput) {
    getUserStatsDistribution(input: $input)
  }
`;
